module.exports = __webpack_public_path__ + "img/Slice4en-min.b6ac38a1.png";